// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Link-shaped reset. \`currentColor\` so the control inherits whatever bar it
   sits in - the table headers are dark, the search modal is white. */
.searchHelp_help__lCVnh {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  border: none;
  background: none;
  padding: 0;
  font: inherit;
  font-size: 0.72rem;
  font-weight: 600;
  color: currentColor;
  opacity: 0.75;
  cursor: help;
  white-space: nowrap;
}

.searchHelp_help__lCVnh:hover,
.searchHelp_help__lCVnh:focus-visible {
  opacity: 1;
  text-decoration: underline;
}

.searchHelp_icon__ClmmM {
  font-size: 0.95rem;
}

/* MUI caps a tooltip at 300px, too narrow for six rules. */
.searchHelp_tooltipRoot__yIBGJ {
  max-width: 25rem !important;
}

.searchHelp_tooltip__YpWHD {
  font-size: 0.75rem;
  line-height: 1.45;
}

.searchHelp_title__QkxTZ {
  font-weight: 700;
  margin-bottom: 0.35rem;
}

.searchHelp_list__z4DUg {
  margin: 0;
  padding-left: 1.1rem;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

/* An example the user is meant to type back, not free text around it. */
.searchHelp_example__ltIeT {
  font-family: monospace;
  font-size: 0.78rem;
  background: rgba(255, 255, 255, 0.16);
  border-radius: 3px;
  padding: 0 0.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchField/searchHelp.module.css"],"names":[],"mappings":"AAAA;qEACqE;AACrE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,wEAAwE;AACxE;EACE,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":["/* Link-shaped reset. `currentColor` so the control inherits whatever bar it\n   sits in - the table headers are dark, the search modal is white. */\n.help {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.2rem;\n  border: none;\n  background: none;\n  padding: 0;\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: currentColor;\n  opacity: 0.75;\n  cursor: help;\n  white-space: nowrap;\n}\n\n.help:hover,\n.help:focus-visible {\n  opacity: 1;\n  text-decoration: underline;\n}\n\n.icon {\n  font-size: 0.95rem;\n}\n\n/* MUI caps a tooltip at 300px, too narrow for six rules. */\n.tooltipRoot {\n  max-width: 25rem !important;\n}\n\n.tooltip {\n  font-size: 0.75rem;\n  line-height: 1.45;\n}\n\n.title {\n  font-weight: 700;\n  margin-bottom: 0.35rem;\n}\n\n.list {\n  margin: 0;\n  padding-left: 1.1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n/* An example the user is meant to type back, not free text around it. */\n.example {\n  font-family: monospace;\n  font-size: 0.78rem;\n  background: rgba(255, 255, 255, 0.16);\n  border-radius: 3px;\n  padding: 0 0.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"help": `searchHelp_help__lCVnh`,
	"icon": `searchHelp_icon__ClmmM`,
	"tooltipRoot": `searchHelp_tooltipRoot__yIBGJ`,
	"tooltip": `searchHelp_tooltip__YpWHD`,
	"title": `searchHelp_title__QkxTZ`,
	"list": `searchHelp_list__z4DUg`,
	"example": `searchHelp_example__ltIeT`
};
export default ___CSS_LOADER_EXPORT___;
